var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.474609,
    width: 33,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1616_1715",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1616_1715",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAACVElEQVR42u2bW07DMBBFPakLtA0SS+lSYCvslO+soUVCCm9iPihSW5CapH6MnXM2UI9P7oyTJsYAAAAAAAAAAAD84JxzmtcnU5YhIurqr0gLQtRJaZpmTctSmAgNLWzyCflH2IKEKJwZqdJCQpQNfEl50hCRlTHmWfsmx0yLpD76xSz2nFpjrZOWNUzmNQlROBdCrpmEjBd7iRBdUl5DdBeEKDseW82PEXKT4mPPSIiytFg2xv9vi0htjGm9Hnszallz59y7xoWN2UNLAoKnZW6M+SxuhjRNs3Y7Mrt4Poas2ZKGqGmRbBOSYxr61NR13WNWQ700CUMHvpqEbDab26nI2LvwlioTMiURp/Y6dUKWU5exd0FWSU9ZiPizH1/JEoIMRcdeZCgSgoyTw91aZOg6aUVJiKaXmRWKqPePvVHuQ0hH/7v14AlBRn8Zwe9DkDG88/CfuiIZQYWQjgMRi74z2bJd6VMRPCEK3he+EZELOSRqe95ut3fFvuTQdd3DbDY7917GaU1FaCHXKQvKrUUFb1nOuaex8f4lUxEzH2u3OV9NpaQi+X1Izkk4qqP2XYfXhOTwYb72dFe5F1Baq60iLH5V0qwIXYsNXMCVMeaNVChIiIgsS5Ax5DmUtoQcL/qFVCRMiHOuK2WA756FJanBlnBVlbR+/qBSdjFZj8VUJuITVc8i1KzdZ8typIKWNYi2be/3RNQa510Jn0UXBUMdIYAQhABCEAIIQQggBCGAEEAIQmAUwpdOnjbS09NxEkLLAoQgBBACAAAAAAAAAAAAUfkGkDUcWdaLMn4AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.21ef2ed02dd59b028a6877193310fbc2.svg";
export { ForwardRef as ReactComponent };